<div
  class="container-fluid justify-content-center mb-0 pt-2 pb-1 pb-xl-2  shadow-lg col-12"
>
  <div class="jumbotron-fluid mx-0 px-0 mt-1 pt-2 mb-0 pb-0">
    <div class="container my-1 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h2 class="rub-head4 text-info text-center font-weight-bold py-1">
            Approvals
          </h2>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-0 mb-0 pb-0">
      <div class="d-flex justify-content-start my-0 pt-2 pb-0 mx-0 px-0">
        <div class="col-12 mx-0 px-0 px-md-1">
          <a routerLink="microloan" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Micro Loans"
            >
              Micro Loans
            </button>
          </a>
          <a routerLink="waiveinterest" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Waive Interest amount"
            >
              Waive
            </button>
          </a>
          <a routerLink="loantenure" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Set Loan tenure"
            >
              Loan Tenure
            </button>
          </a>
          <a routerLink="loanamortizetype" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Loan Amortization Type"
            >
              Amort'n Type
            </button>
          </a>
          <a routerLink="reverseinterest" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Reverse Interest"
            >
              Reverse Interest
            </button>
          </a>
          <a routerLink="reverseprincipal" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Reverse Principal"
            >
              Reverse Principal
            </button>
          </a>
          <a routerLink="loanlimit" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Set Loan limit"
            >
              Loan limit
            </button>
          </a>
          <a routerLink="interestrate" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Set Interest rate"
            >
              Rate
            </button>
          </a>
          <a routerLink="writeoff" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Write-Off Principal"
            >
              Write Off
            </button>
          </a>
          <a routerLink="loanaccrualdays" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Set Loan Accrual Days"
            >
              Accrual Days
            </button>
          </a>
          <a routerLink="loanamortizecycle" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Loan Amortization Cycles"
            >
              Amort'n Cycles
            </button>
          </a>
          <a routerLink="withdrawsavings" class="text-info mb-1">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-1"
              tooltip="Withdraw Savings"
            >
              Withdraw
            </button>
          </a>
          <a routerLink="accruedinterest" class="text-info mb-1">
            <button class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-1" tooltip="Accrued Interest">
              Accrual Method
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
